var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInitiativeDetailRealtime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.18906 1.04552C8.32734 0.724431 8.22421 0.349431 7.94062 0.143181C7.65703 -0.0630692 7.27031 -0.0443192 7.00546 0.185368L1.00546 5.43537C0.771089 5.64162 0.686714 5.97209 0.79687 6.26271C0.907026 6.55334 1.18828 6.75021 1.49999 6.75021H4.11328L2.31093 10.9549C2.17265 11.276 2.27578 11.651 2.55937 11.8572C2.84296 12.0635 3.22968 12.0447 3.49453 11.8151L9.49453 6.56506C9.7289 6.35881 9.81328 6.02834 9.70312 5.73771C9.59296 5.44709 9.31406 5.25256 9 5.25256H6.38671L8.18906 1.04552Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitiativeDetailRealtime);
export default __webpack_public_path__ + "static/media/initiative-detail-realtime.ff125794c9ec1524a88558cd9cc400cd.svg";
export { ForwardRef as ReactComponent };